import type { IconData } from '@stacksjs/iconify-core'

export const cloudF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13 0a7 7 0 0 1 0 14H5a5 5 0 1 1 1.561-9.751A7 7 0 0 1 13 0\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default cloudF
